import React, { useContext, useEffect } from 'react';
import { ContentLayout } from 'src/components/ContentLayout';
import { ApplicationList } from 'src/components/ApplicationList';
import { AccountHeader } from 'src/components/AccountHeader';
import { useParams } from 'react-router-dom';
import { SharedModelsTable } from 'src/components/SharedModelsTable';
import { Link } from 'src/components/Link';
import { AccountContext } from 'src/context/accountContext';
import { Alert, Box, SpaceBetween } from '@cloudscape-design/components';

export const AccountPage = () => {
  const { isNewAccount, accountNo } = useParams();
  const { selectedAccount } = useContext(AccountContext);

  useEffect(() => {
    // start a performance mark
    performance.mark('accountPageLoaded');
  }, []);

  return (
    <ContentLayout heading={<AccountHeader />}>
      {isNewAccount && (
        <Box margin={{ bottom: 'm' }}>
          <Alert
            header="Don't Forget"
            action={
              <Link to={`/accounts/${selectedAccount?.id}/topics`}>
                Create a Topic Subscription
              </Link>
            }
          >
            You&apos;ll need to create a Topic Subscription in order to send
            events to MLPigeon.
          </Alert>
        </Box>
      )}
      <SpaceBetween size="xl">
        <ApplicationList />
        <SharedModelsTable awsAccount={accountNo} />
      </SpaceBetween>
    </ContentLayout>
  );
};
